// hooks
import useHttp from "hooks/use-http";
import useAuth from "hooks/use-auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useInputValue } from "hooks/use-input-value";

// material components
import {
  Button,
  FormControl,
  Stack,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";

// react icons
import { MdRefresh } from "react-icons/md";

// assests (logo image)
import logo from "assets/img/logo512.png";

// request methods
import { login as loginRequest } from "api/requests/adminLogin";

// material icons
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// components
import LoadingCM from "components/shared/Loading";
import { Wrapper } from "components/shared/Wrapper";
import ImgContainer from "components/shared/Image";

// styled components
import {
  StyledBox,
  StyledBoxContainer,
  StyledStack,
  StyledImgContainer,
} from "./Login.style";

// helpers
import { convertNum } from "helper/convert-num";
import Toast from "helper/toast";

// captcha library
import Captcha from "captcha-image";

export default function Login() {
  const navigate = useNavigate();
  const name = useInputValue("");
  const password = useInputValue("");
  const captcha = useInputValue("");
  const [randomCaptcha, setRandomCaptcha] = useState({ image: "", word: "" });
  const [toggle, setToggle] = useState({ passwordVisibility: false });

  const { request, loading, setLoading } = useHttp(true);
  const authCTX = useAuth();

  const handleChange = () =>
    setToggle({ passwordVisibility: !toggle.passwordVisibility });

  const handleSubmit = async () => {
    if (
      [name.value.trim(), password.value.trim(), captcha.value.trim()].includes(
        ""
      )
    ) {
      return Toast({ type: "empty", title: "لطفا تمام فیلد " });
    }
    if (captcha.value.trim() !== randomCaptcha.word)
      return Toast({ type: "custom", title: " کد امنیتی وارد شده اشتباه است" });

    let res = await request({
      url: loginRequest,
      values: { name: name.value, password: convertNum(password.value) },
    });

    authCTX.login(res.data);
    navigate("/home");
  };

  const generateCaptcha = () => {
    const captchaImage = new Captcha(
      "35px IranSans",
      "center",
      "middle",
      150,
      50,
      "#eee",
      "#111",
      6
    ).createImage();

    function createMarkup(source) {
      return { __html: source };
    }

    function MyCaptcha() {
      return <div dangerouslySetInnerHTML={createMarkup(captchaImage)} />;
    }

    let randomWord = captchaImage.split("data-key")[1].split('"')[1];

    setRandomCaptcha({ image: <MyCaptcha />, word: randomWord });
    setLoading(false);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);
  return (
    <>
      {loading && <LoadingCM />}
      <Wrapper>
        <StyledStack spacing={10} p={{ sm: 3, xs: 3 }}>
          <ImgContainer
            src={logo}
            alt="لوگو"
            objectFit="contain"
            width="100px"
            style={{
              marginTop: "10px",
              borderRadius: "18px",
              padding: "10px",
            }}
          />
          <FormControl style={{ marginTop: "40px" }}>
            <Stack spacing={2} justifyContent="center" alignItems="center">
              <TextField
                id="username"
                label="نام کاربری"
                variant="outlined"
                fullWidth
                {...name}
                size="small"
              />
              <TextField
                id="password"
                label="رمز عبور"
                variant="outlined"
                fullWidth
                size="small"
                {...password}
                type={toggle.passwordVisibility ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleChange}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        {toggle.passwordVisibility && <Visibility />}
                        {!toggle.passwordVisibility && <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Stack
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <TextField
                  id="captcha"
                  label="کد امنیتی"
                  variant="outlined"
                  sx={{ width: "65%" }}
                  {...captcha}
                  size="small"
                />
                <StyledBoxContainer item>
                  <StyledBox>{randomCaptcha.image}</StyledBox>

                  <MdRefresh
                    size={22}
                    onClick={generateCaptcha}
                    style={{ marginTop: "10px" }}
                  />
                </StyledBoxContainer>
              </Stack>
              <Button variant="contained" onClick={handleSubmit} fullWidth>
                ورود
              </Button>
            </Stack>
          </FormControl>
        </StyledStack>
        <StyledImgContainer src={logo} alt="لوگو" objectFit="contain" />
      </Wrapper>
    </>
  );
}
